var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3521 17.2055L7.53379 22.6823C5.56154 21.671 3.90669 20.1354 2.75092 18.2452C1.75057 16.6101 1.15846 14.7571 1.02821 12.8451C1.00742 12.566 0.997568 12.2759 0.997568 12.0001C0.995379 10.2818 1.36422 8.58427 2.07891 7.02355C2.15662 6.85062 2.23761 6.68207 2.32298 6.51352C2.40835 6.34497 2.51233 6.17204 2.60207 6.00568C2.66665 5.89186 2.73451 5.78022 2.80346 5.66968L3.11976 6.00568L5.0548 7.91993L7.54583 10.3836C7.45499 10.7098 7.39151 11.0436 7.35649 11.3807C7.33788 11.5821 7.32584 11.7867 7.32584 11.9925C7.32584 13.0508 7.60712 14.0906 8.13904 15.0056C8.67205 15.9206 9.43709 16.6779 10.3586 17.2L10.3521 17.2055Z",
    fill: "url(#paint0_linear_867_10340)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5211 1.3377L15.832 6.56165C15.5737 6.44125 15.3066 6.33947 15.0341 6.25848C14.2012 6.01003 13.3256 5.94546 12.4654 6.07023C11.6051 6.1939 10.7831 6.50364 10.0542 6.97755C10.2797 5.48577 10.4887 4.14723 10.4887 4.14723C10.4887 4.14723 10.805 2.63028 9.11845 2.89186C8.15531 2.99036 6.08565 3.29353 4.49756 3.53432C6.29907 1.72515 8.63031 0.537636 11.152 0.143624C13.6748 -0.250388 16.2566 0.169892 18.5244 1.34317L18.5211 1.3377Z",
    fill: "#FFCB05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4884 4.14802C10.4884 4.14802 10.2793 5.48657 10.0539 6.97834C9.83387 8.42086 9.59527 10.0111 9.50552 10.6689C9.31618 12.0129 8.53363 11.3705 8.53363 11.3705L7.54422 10.392L3.11815 6.01301L2.80184 5.67701L1.91094 4.72919C1.541 4.0736 2.34873 3.86127 2.34873 3.86127C2.34873 3.86127 3.29655 3.71351 4.4961 3.52964C6.09403 3.28885 8.15494 2.98568 9.11698 2.88718C10.8047 2.63654 10.4884 4.14802 10.4884 4.14802Z",
    fill: "#1B9948"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0022 12.0001C25.0044 13.9165 24.5458 15.8067 23.6636 17.5086L18.5699 14.8851C18.965 14.1649 19.208 13.3703 19.2835 12.5528C19.359 11.7341 19.2649 10.91 19.0088 10.1285C18.7516 9.34813 18.3368 8.62906 17.7907 8.01506C17.2445 7.40106 16.5769 6.90635 15.8315 6.56159L18.5218 1.33765C18.8326 1.49853 19.1358 1.67365 19.428 1.85862C21.1376 2.94106 22.5451 4.4394 23.5203 6.21245C24.4932 7.98551 25.0033 9.97637 25.0022 12.0001Z",
    fill: "url(#paint1_linear_867_10340)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6636 17.5097C23.297 18.2178 22.8614 18.8877 22.3634 19.5093C22.0416 19.9055 21.6968 20.282 21.328 20.6355C20.6757 21.266 19.9533 21.8209 19.1762 22.2882C17.4273 23.3367 15.4408 23.9233 13.404 23.9934C11.3661 24.0623 9.34455 23.6125 7.52881 22.6844L10.3471 17.2087C11.0508 17.6093 11.829 17.8632 12.6335 17.9552C13.4379 18.0471 14.2533 17.9749 15.0293 17.7439C15.3784 17.6389 15.7188 17.502 16.0439 17.3368C16.6425 17.0292 17.1854 16.6243 17.6495 16.1372C17.8673 15.9074 18.0675 15.6622 18.2481 15.4017C18.362 15.2354 18.4681 15.0646 18.5644 14.8884L23.6636 17.5097Z",
    fill: "url(#paint2_linear_867_10340)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_867_10340",
    x1: -1.75846,
    y1: 9.04923,
    x2: 9.67354,
    y2: 17.6986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1B9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4070B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_867_10340",
    x1: 28.3362,
    y1: 16.0291,
    x2: 16.2957,
    y2: 6.07565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DB2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DC2627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DD3226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E14726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E56324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA8523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EE931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F7B110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FDC408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_867_10340",
    x1: 12.004,
    y1: 24.4781,
    x2: 18.5531,
    y2: 15.2923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4070B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#4070B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#436FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4C6DAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5C68A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#71628E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8E5B77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A55463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#C7343D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DB2227"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundIcon);
export default __webpack_public_path__ + "static/media/roundIcon.e1b033809891cc4bf27779579735446b.svg";
export { ForwardRef as ReactComponent };